import { render } from "./DefaultTemplate.vue?vue&type=template&id=0fb9b4ac"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__